var map = {
	"./Group (1).svg": "aa16",
	"./Group (14).svg": "f7ec",
	"./Group (15).svg": "85f3",
	"./Group (16).svg": "c65d",
	"./Group (17).svg": "bcb5",
	"./Group.svg": "5672",
	"./address_of_contracting.svg": "3102",
	"./alcohol.svg": "dfcf",
	"./applicant_address.svg": "3a39d",
	"./applicants_details.svg": "cc11",
	"./applicants_employment_data.svg": "9bbd",
	"./beneficiaries.svg": "25d2",
	"./collection.svg": "c950",
	"./contracting_data.svg": "c712",
	"./contractor_contact.svg": "3134",
	"./coverages.svg": "defb",
	"./diseases.svg": "8470",
	"./documents.svg": "d254",
	"./finished.svg": "a66b",
	"./foncabsa.svg": "a858",
	"./hello.svg": "1eb5",
	"./hobbies.svg": "9822",
	"./labor_data_of_the_contractor.svg": "f888",
	"./operations.svg": "cd2c",
	"./personal_info.svg": "d145",
	"./profession_occupation.svg": "9952",
	"./quotation.svg": "77b1",
	"./smoke.svg": "f99a",
	"./sports.svg": "31d3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eb97";